import React, { Fragment, useContext } from "react";
import classnames from "classnames";
import { MobileContext, LayoutContext } from "../common/wrappers";
import NavbarDesktop from "./Navbar/NavbarDesktop";
import HeaderMobile from "./Header/HeaderMobile";
import HeaderDesktop from "./Header/HeaderDesktop";
import Drawer from "./Drawer";
import PersistentModal from "../common/modals/PersistentModal";
import PersistentOverlay from "../common/overlays/PersistentOverlay";
import { aux } from "../../theme";
import ActivationBanner from "./Banner/ActivationBanner";

const Layout = ({ children }) => {
  const { navWidth, navHeight } = useContext(LayoutContext);
  const { isMobile } = useContext(MobileContext);
  const renderDesktop = () => (
    <>
      <div
        className="fixed h-screen z-10 overflow-hidden"
        style={{ width: navWidth, zIndex: 30 }}
      >
        <NavbarDesktop />
      </div>
      <div
        className="flex flex-col flex-1 w-full"
        style={{ marginLeft: navWidth }}
      >
        <div
          className="fixed shadow-header z-10"
          style={{
            height: navHeight,
            marginLeft: `-${navWidth}`,
            width: `calc(100% - ${navWidth}px)`,
          }}
        >
          <HeaderDesktop />
        </div>
        <div
          className={classnames(
            "page w-full dashboard-max-w lg:mx-auto relative pt-12 h-full",
            // {
            //   "pt-12": !showCreditLimitBanner,
            //   "pt-20": showCreditLimitBanner
            // }
          )}
        >
          <ActivationBanner />
          {children}
        </div>
      </div>
    </>
  );

  const renderMobile = () => (
    <>
      <div className="fixed z-10 w-full" style={{ height: navHeight }}>
        <HeaderMobile />
      </div>
      <div
        className="flex-1 w-full"
        style={{
          marginBottom: 0,
        }}
      >
        <div
          className={classnames(
            "page w-full dashboard-max-w lg:mx-auto relative",
            // {
            //   "pt-24": showCreditLimitBanner
            // }
          )}
        >
          <ActivationBanner />
          {children}
        </div>
      </div>
      <div
        className="fixed w-full"
        style={{
          bottom: aux.mobile.navbarHeight,
          zIndex: 60,
        }}
      />
      {/* {hasCriticalNotifications && (
        <div
          className="fixed w-full"
          style={{
            bottom: aux.mobile.navbarHeight,
            zIndex: 60
          }}
        >
          <BannerCriticalMobile />
        </div>
      )} */}
      {/* <NavbarMobile /> */}
    </>
  );

  return (
    <div className="flex bg-background min-h-screen">
      {isMobile ? renderMobile() : renderDesktop()}
      <Drawer />
      <PersistentModal />
      <PersistentOverlay />
    </div>
  );
};

export default Layout;
